import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Globals } from 'src/app/common/globals';
import { firstValueFrom } from 'rxjs';
import { CommonService } from 'src/app/common/services/common.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(
    private http: HttpClient,
    private globals: Globals,
    private commonService: CommonService,
    private router: Router
  ) { }

  getCountries() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/countries')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getLicenseType(is_issuing_type: 1 | 0 = 1) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/license-types/' + is_issuing_type)
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getAddressTypes() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/address-types')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getStates(id: string) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/states/' + id)
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getSchoolTypes() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/school-type/1')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getSchools() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/master/homeopathy-schools/0/1'
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getPrograms() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/homeopathy-programs/1')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getPhonePrefix() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/phone-prefix')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }
  getNamePrefix() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/name-prefixes')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getNonHomeopathyEdu() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/master/non-homeopathy-education/1'
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getLicenseTypes() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/master/professional-healthcare-license/1'
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getAgeGroups() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/age-groups')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getGenders() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/genders')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getRaces() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/race-ethnicities')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getEthnicities() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/ethnicity/1')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getDisabilities() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/disability/1')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getClientTypes() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/client-type/1')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getLanguages() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/languages/1')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getCommittees() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/committee-type/1')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  setPersonalInfo(data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.put(this.globals.baseAPIUrl + '/profile/personal-info', data)
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getAddressInfo(id: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/profile/address-details/' + id
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  setAddressInfo(id: string | null, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(
          this.globals.baseAPIUrl + '/profile/address-details/' + id,
          data
        )
      ).then(
        (res) => {
          this.updateAuth(id);
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  addLicense(data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(this.globals.baseAPIUrl + '/profile/license-info', data)
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  updateLicense(id: string | null, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.put(
          this.globals.baseAPIUrl + '/profile/license-info/' + id,
          data
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  deleteLicense(id: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.delete(
          this.globals.baseAPIUrl + '/profile/license-info/' + id
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getEducationInfo(id: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/profile/education-details/' + id
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  setEducationInfo(id: string | null, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(
          this.globals.baseAPIUrl + '/profile/education-details/' + id,
          data
        )
      ).then(
        (res) => {
          this.updateAuth(id);
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getDemographicInfo(id: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/profile/demograffic-details/' + id
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  setDemographicInfo(id: string | null, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(
          this.globals.baseAPIUrl + '/profile/demograffic-details/' + id,
          data
        )
      ).then(
        (res) => {
          this.updateAuth(id);
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getVolunteerInfo(id: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/profile/volunteer-details/' + id
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  setVolunteerInfo(id: string | null, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(
          this.globals.baseAPIUrl + '/profile/volunteer-details/' + id,
          data
        )
      ).then(
        (res) => {
          this.updateAuth(id);
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getDirectoryInfo(id: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/profile/directory-details/' + id
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  setDirectoryInfo(id: string | null, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(
          this.globals.baseAPIUrl + '/profile/add-directory-details/' + id,
          data
        )
      ).then(
        (res) => {
          this.updateAuth(id);
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  setPassword(id: string | null, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.put(
          this.globals.baseAPIUrl + '/settings/change-password/' + id,
          data
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  uploadProfile(id: string | null, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(
          this.globals.baseAPIUrl + '/profile/uploadUserLogo',
          data
        )
      ).then(
        (res) => {
          this.updateAuth(id);
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }
  deleteProfilePhoto(id: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/profile/deleteUserLogo/' + id)
      ).then(
        (res) => {
          this.updateAuth(id);
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getUserDetails(userId: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl +
          '/profile/personal-info' +
          (userId ? '/' + userId : '')
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getAuthUserData(userId: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/user-info/' + userId + '/1')
      ).then(
        (res: any) => {
          resolve(res);

          this.commonService.setCookie('logged_in_user_info', res.data);
          this.globals.authData = res.data;
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  // syncAuth(actualData: any, updateData: any): any {
  //   // 1. Create a copy of the original data
  //   const result = { ...actualData };

  //   const fieldsToUpdate = [
  //     'first_name',
  //     'last_name',
  //     'name_initials',
  //     'email',
  //   ];

  //   fieldsToUpdate.forEach((field) => {
  //     if (updateData[field] !== undefined && updateData[field] !== null) {
  //       result[field] = updateData[field];
  //     }
  //   });

  //   // 3. Store in cookie (only the updated fields + preserved original data)
  //   this.commonService.setCookie(
  //     'logged_in_user_info',
  //     JSON.stringify(result) // Contains original data + updates
  //   );

  //   this.globals.authData = result;

  //   return result;
  // }

  getUserInfoFlag(userId: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl +
          '/profile/user-info-flag' +
          (userId ? '/' + userId : '')
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getGovtDocs(userId: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl +
          '/profile/govt-docs' +
          (userId ? '/' + userId : '')
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  // profile/address-info
  addressInfo(userId: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl +
          '/profile/address-info' +
          (userId ? '/' + userId : '')
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  addAddressInfo(id: string | null, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(
          this.globals.baseAPIUrl + '/profile/address-info/' + id,
          data
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  updateAddressInfo(id: string | null, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.put(
          this.globals.baseAPIUrl + '/profile/address-info/' + id,
          data
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  deleteAddressInfo(id: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.delete(
          this.globals.baseAPIUrl + '/profile/address-info/' + id
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  setAddressAsDefault(id: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.put(
          this.globals.baseAPIUrl + '/profile/address-info/' + id + '/set-default',
          {}
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  updateAuth(id: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/admin/get-user-details/' + id)
      ).then(
        (res: any) => {
          let result = res['data'];
          this.commonService.setCookie('logged_in_user_info', result);
          var link = this.globals.currentLinkArr[2];
          this.commonService.syncAuthGlobals();
          if (
            this.globals.authData.profileInfoValid &&
            this.globals.authData.directoryInfoValid &&
            this.globals.authData.volunteerInfoValid
          ) {
            if (
              link == 'required' &&
              localStorage.getItem('complete_Profile_btn_click') == null
            ) {
              var msg = `Your Profile is now complete. You can proceed to your Application by clicking below button.`;
              Swal.fire({
                title: 'Profile Completed!',
                text: msg,
                confirmButtonText: 'Proceed to your Application',
                showCancelButton: true,
                reverseButtons: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.router.navigate(['/professional']);
                }
              });
              // var msg = 'Your Profile is now complete. You can proceed to your <a href="/professional">Application</a>.'
              // this.commonService.showCommonSuccessNotification(msg);
              this.router.navigate(['/profile']);
            }
            if (
              link == 'required' &&
              localStorage.getItem('complete_Profile_btn_click')
            ) {
              this.router.navigate(['/professional']);
              this.commonService.showCommonSuccessNotification(
                'Your Profile is now complete. You can start the application.'
              );
              localStorage.removeItem('complete_Profile_btn_click');
            }
          }

          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  setEmail(data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(this.globals.baseAPIUrl + '/change-email', data)
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  lastEmailChangeRequest(id: string) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/get-last-email-change-request/' + id
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  resendEmail(id: string) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl +
          '/resend-email-change-verification-email/' +
          id
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  cancelEmailChangeRequest(id: string) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/cancel-email-change-request/' + id
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  checkEmail(email: string, user_id: string | null = null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl +
          '/user/check-email/' +
          email +
          (user_id ? '/' + user_id : '')
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  registration(entity: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(this.globals.baseAPIUrl + '/user/registration', entity)
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getGovtDocTypes() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/master/govt-document-types')
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  addGovtDoc(data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(this.globals.baseAPIUrl + '/profile/govt-docs', data)
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  updateGovtDoc(id: string, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.put(
          this.globals.baseAPIUrl + '/profile/govt-docs/' + id,
          data
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  deleteGovtDoc(id: string) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.delete(this.globals.baseAPIUrl + '/profile/govt-docs/' + id)
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getExperience(userId: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl +
          '/profile/experience-info' +
          (userId ? '/' + userId : '')
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getLicenseInfo(userId: string | null) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl +
          '/profile/license-info' +
          (userId ? '/' + userId : '')
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  addExperience(data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(
          this.globals.baseAPIUrl + '/profile/experience-info',
          data
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  updateExperience(id: string, data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.put(
          this.globals.baseAPIUrl + '/profile/experience-info/' + id,
          data
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  deleteExperience(id: string) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.delete(
          this.globals.baseAPIUrl + '/profile/experience-info/' + id
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }
  changeEmailSendOtp(data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(
          this.globals.baseAPIUrl + '/settings/change-email/send-otp',
          data
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }
  verifyChangeEmail(data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(
          this.globals.baseAPIUrl + '/settings/verify-change-email',
          data
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getSecurityQuestion() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(this.globals.baseAPIUrl + '/settings/security-question')
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }
  changeSecuritySendOtp() {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/settings/security-question/send-otp',
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  verifySecurityOtp(data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.post(
          this.globals.baseAPIUrl +
          '/settings/security-question/verify-send-otp',
          data
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  updateSecurityQuestion(data: any,) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.put(
          this.globals.baseAPIUrl + '/settings/security-question',
          data
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  updateMarketingConsent(data: any) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.put(
          this.globals.baseAPIUrl + '/profile/marketing-consent',
          data
        )
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getSystemConsents(type: string) {
    return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl + '/master/system-consents' + '/' + type),
      ).then(
        (res) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

   getConsentFlags(userId:any){
     return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl +
          '/profile/consent-flags/'+ userId
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

  getPaymentHistory(userId:any){
     return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl +
          '/admin/manage/user/get-all-transactions/'+ userId
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }

   getUserDocsInfo(userId:any){
     return new Promise((resolve, reject) => {
      firstValueFrom(
        this.http.get(
          this.globals.baseAPIUrl +
          '/admin/manage/user/files/'+ userId
        )
      ).then(
        (res: any) => {
          resolve(res);
        },
        (msg) => {
          reject(msg);
        }
      );
    });
  }
 
}
